import { html } from 'lit';
const HighHeelPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M19.593 14.094c-2.382-1.429-5.838-1.47-7.763-3.473L7.12 5.725c-.445-.463-1.064-.748-1.698-.642-1.681.28-3.462 1.332-1.683 4.11 2.147 3.355 2.409 7.27 2.27 8.807h1.653v-2.802c0-.653.529-1.182 1.182-1.182h.067c.26 0 .515.087.722.246l3.2 2.47a6.09 6.09 0 0 0 7.406.024l.41-.313a1.073 1.073 0 0 0-.098-1.774z"/>
  </svg>
`;
export default HighHeelPanel;
